<template>
  <div>
    <h1 class="text-md-h6 text-subtitle-1 font-weight-bold my-3">
      <translate>Overview</translate> {{ course.name }}
    </h1>

    <v-card class="pa-md-6 pa-4">
      <h5
        v-if="course && course.holeTotal"
        class="page-subtitle my-6 d-flex justify-space-between align-center"
      >
        <div>
          <translate>Number of Holes: </translate>
          <span class="red--text ml-1">{{ course.holeTotal }}</span>
        </div>
        <div class="actionSection ml-4">
          <ButtonEdit
            v-if="isCourseAdmin"
            :text="$gettext('Edit')"
            @click="$emit('editHoleTable')"
          />
        </div>
      </h5>

      <ul class="holes d-flex pl-0">
        <li class="subtitle-2" v-for="(hole, index) in holesList" :key="index">
          {{ hole.name }}
          <v-icon color="#27AE60" v-if="hole.status"
            >fas fa-circle-check</v-icon
          >
          <v-icon color="#EB5757" v-else>fas fa-circle-xmark</v-icon>
        </li>
      </ul>
    </v-card>
  </div>
</template>

<script>
import ButtonEdit from "@/components/Buttons/ButtonEdit";
export default {
  name: "HoleAboutCourse",
  props: {
    isCourseAdmin: { type: Boolean, default: false },
  },
  components: {
    ButtonEdit,
  },
  data() {
    return {};
  },
  computed: {
    course() {
      return this.$store.state.golfcourse.courseDetail;
    },
    holesList() {
      return [
        {
          name: this.$gettext("Driving Range"),
          status: this.course ? this.course.drivingRange : false,
        },
        {
          name: this.$gettext("Pro Shop"),
          status: this.course ? this.course.proShop : false,
        },
        {
          name: this.$gettext("Putting Green"),
          status: this.course ? this.course.puttingGreen : false,
        },
        {
          name: this.$gettext("Golf Lessons"),
          status: this.course ? this.course.golfLesson : false,
        },
        {
          name: this.$gettext("Chipping Green"),
          status: this.course ? this.course.chippingGreen : false,
        },
        {
          name: this.$gettext("Caddie Hire"),
          status: this.course ? this.course.caddieHire : false,
        },
        {
          name: this.$gettext("Practice Bunker"),
          status: this.course ? this.course.practiceBunker : false,
        },
        {
          name: this.$gettext("Restaurant"),
          status: this.course ? this.course.restaurant : false,
        },
        {
          name: this.$gettext("Motor Cart"),
          status: this.course ? this.course.motorCart : false,
        },
        {
          name: this.$gettext("Reception Hall"),
          status: this.course ? this.course.receptionHall : false,
        },
        {
          name: this.$gettext("Pull Cart"),
          status: this.course ? this.course.pullCart : false,
        },
        {
          name: this.$gettext("Changing Room"),
          status: this.course ? this.course.changingRoom : false,
        },
        {
          name: this.$gettext("Golf Clubs Rental"),
          status: this.course ? this.course.golfClubRental : false,
        },
        {
          name: this.$gettext("Lockers"),
          status: this.course ? this.course.lockers : false,
        },
        {
          name: this.$gettext("Club Fitting"),
          status: this.course ? this.course.clubFitting : false,
        },
        {
          name: this.$gettext("Lodging on Site"),
          status: this.course ? this.course.lodgingOnSite : false,
        },
      ];
    },
  },
  methods: {},
};
</script>
